export default Object.freeze({
  getRegistries: {
    GET: () => {
      return `registries`;
    },
  },
  getReservedNumbers: {
    GET: (registryId) => {
      return `registries/${registryId}/reservedNumbers`;
    },
  },
  reserveNumbers: {
    GET: (registryId) => {
      return `registries/${registryId}/reservedNumbers`;
    },
  },
  getRegistryStats: {
    GET: (registryId) => {
      return `registries/${registryId}/stats`;
    },
  },
  getRegistryEntries: {
    GET: () => {
      return `registries/entries`;
    },
  },
});
